import { labelFade } from "./labels";
import { selectJs } from "./select";

const $target = $("#customer-fields");
const config = { childList: true, subtree: true };

function selectLogic($target) {
  selectJs($target.find("select"));
  labelFade("input.customr-control");
  $target.find('input[type="checkbox"]').wrap('<div class="checkbox"></div>');
  $target.find('input[type="checkbox"]').after("<span></span>");
}

const callback = function(mutationsList, observer) {
  if ($target.find("select").length) {
    selectLogic($target);
    observer.disconnect();
  }
};

const $defaultTarget = $("#customer-fields");
if (!$defaultTarget.find("select").parent().hasClass(".selectric-hide-select")) {
  selectLogic($defaultTarget);
}

const observer = new MutationObserver(callback);
if ($target.length) {
  observer.observe($target[0], config);
}



// WEBPACK FOOTER //
// ../assets/js/customr.js